// Mint-KPI · tab Quy tắc KPI — danh mục chỉ số (TblKPIDef, Kind = Metric) từ code board. Mã chỉ số tiền (S_PROFIT, D_COST) ẩn khi chưa có quyền tiền.
export type KpiKind = 'Metric' | 'Unit' | 'Param' | 'Penalty' | 'Reward' | 'Severity';
export const KPI_KINDS: { key: KpiKind; label: string }[] = [
  { key: 'Metric', label: 'Chỉ số' },
  { key: 'Unit', label: 'Điểm sản lượng' },
  { key: 'Param', label: 'Tham số' },
  { key: 'Penalty', label: 'Phạt' },
  { key: 'Reward', label: 'Thưởng' },
  { key: 'Severity', label: 'Mức độ' },
];
// [mã, phòng, tên, đơn vị, hướng, nguồn]
export const KPI_METRICS: [string, string, string, string, string, string][] = [
  ["S_TEU", "SALE", "Sản lượng TEU", "n", "Higher", "bkg"],
  ["S_NEWCUS", "SALE", "Khách hàng mới", "n", "Higher", "bkg"],
  ["S_TASK", "SALE", "Task SBY/FRT/RQU/RBL đúng hạn", "%", "Higher", "tasks"],
  ["S_CANCEL", "SALE", "Tỷ lệ No Show / Cancel", "%", "Lower", "bkg"],
  ["S_DEBT", "SALE", "Công nợ quá hạn (>30 ngày)", "%", "Lower", "invout"],
  ["C_MAIL", "CS", "MailTask xử lý đúng 5 phút", "%", "Higher", "tasks"],
  ["C_TASK", "CS", "Task FBL/SNO/PSI/RMB/MBL đúng hạn", "%", "Higher", "tasks"],
  ["C_SI", "CS", "SI tạo trước Close Doc", "%", "Higher", "bkg,si"],
  ["C_AMEND", "CS", "Job phải Amend", "%", "Lower", "bkg"],
  ["C_VOL", "CS", "Số job xử lý", "n", "Higher", "bkg"],
  ["B_SEND", "BOOKING", "Gửi booking hãng tàu đúng hạn", "%", "Higher", "stamp"],
  ["B_RQU", "BOOKING", "Xử lý RQ Update / No Space đúng hạn", "%", "Higher", "stamp"],
  ["B_CFM", "BOOKING", "BK Confirmed trước Close Doc", "%", "Higher", "stamp"],
  ["B_MAIL", "BOOKING", "Mail hộp booking trả lời đúng hạn", "%", "Higher", "stamp"],
  ["B_ATD", "BOOKING", "ATD Confirm trong ngày tàu chạy", "%", "Higher", "stamp"],
  ["O_ONTIME", "OPS", "Dịch vụ hoàn thành đúng hạn", "%", "Higher", "svc"],
  ["O_LATEH", "OPS", "Giờ trễ trung bình", "h", "Lower", "svc"],
  ["O_LEAD", "OPS", "Lead time trung bình", "h", "Lower", "svc"],
  ["O_OVERDUE", "OPS", "Việc đang quá hạn", "n", "Lower", "svc"],
  ["O_VOL", "OPS", "Số dịch vụ hoàn thành", "n", "Higher", "svc"],
  ["D_TASK", "DISPATCH", "Gán xe / Finish đúng hạn (TVA/TFN)", "%", "Higher", "tasks"],
  ["D_FINISH", "DISPATCH", "Chuyến đã Finish (≥2 ngày)", "%", "Higher", "trf"],
  ["D_TRIPS", "DISPATCH", "Số chuyến điều phối", "n", "Higher", "trf"],
  ["R_TRIPS", "DRIVER", "Số chuyến chạy", "n", "Higher", "trf"],
  ["R_GPS", "DRIVER", "Bấm Bắt đầu / Kết thúc chuyến", "%", "Higher", "trf"],
  ["R_INCIDENT", "DRIVER", "Báo cáo sự cố", "n", "Lower", "trfRep"],
  ["R_LATE", "DRIVER", "Phút đi muộn (chấm công)", "n", "Lower", "chk"],
  ["A_PIAGE", "ACC", "Nhập HĐ đầu vào sau ngày HĐ", "ngày", "Lower", "iin"],
  ["A_PAY", "ACC", "Thanh toán đối tác đúng hạn", "%", "Higher", "pay"],
  ["A_APPROVE", "ACC", "HĐ đầu vào đã duyệt", "%", "Higher", "iin"],
  ["A_DEBT", "ACC", "Công nợ phải thu quá hạn (toàn công ty)", "%", "Lower", "invout"],
  ["A_VOL", "ACC", "Số chứng từ xử lý", "n", "Higher", "iin,pay"],
  ["G_LATE", "*", "Chuyên cần (phút đi muộn)", "n", "Lower", "chk"],
];
export const KPI_PENALTY: [string, string][] = [["P_AMEND","Sai chứng từ → phí amend/manifest"],["P_SILATE","Trễ SI/VGM → phí trễ/rớt tàu"],["P_DEMDET","Trễ lấy/trả cont → DEM/DET/lưu bãi"],["P_TRUCK","Điều xe sai → phí chờ/neo xe"],["P_INVOICE","Sai hoá đơn / thanh toán nhầm"],["P_LOSTDOC","Mất / hư hỏng chứng từ"],["P_NOTIFY","Quên thông báo khách"],["P_CLAIM","Khách khiếu nại có căn cứ"],["P_PROCESS","Vi phạm quy trình"]];
